import io from 'socket.io-client'

angular.module('clientDashboardApp').factory('Socket', function ($rootScope, $q) {

  // Todo add host name to as config during build.
  let socketEndPoint = "https://socketrelay-live.chatmeter.com/chatmeter";
  let socket = null;
  let listeners = {};

  function init() {
    socket = io.connect(socketEndPoint);
    let completed = $q.defer()
    socket.on('connect', () => completed.resolve(true))
    socket.on('connect_error', () => completed.reject(false))
    return completed.promise;
  }

  var on = function (eventName, callback) {
    let ready = $q.when(true);
    if (socket === null) ready = init();

    listeners[eventName] = 1;
    socket.on(eventName, function () {
      var args = arguments;
      $rootScope.$applyAsync(function () {
        callback.apply(socket, args);
      });
    });

    return ready;
  };

  var emit = function (eventName, data, callback) {
    socket.emit(eventName, data, function () {
      var args = arguments;
      $rootScope.$applyAsync(function () {
        if (callback) {
          callback.apply(socket, args);
        }
      });
    });
  };

  var off = function (name) {
    delete listeners[name];
    if (socket !== null) {
      socket.removeAllListeners(name);
      if (Object.keys(listeners).length == 0) {
        socket.disconnect();
        socket = null;
      }
    }
  };

  return {on, emit, off};
});
